import { createReducer, on } from '@ngrx/store';

import { GroupingTagItemEntity } from '../domain/grouping-tag-item.entity';
import {
	fetchProjectCountByGroupingTagSuccess,
	fetchReferencedProjectsByGroupingTagIdSuccess,
	getGroupingTagsPageSuccess,
} from './grouping-tag.actions';
import { GroupingTagMainSliceState } from './grouping-tag.state';

export const groupingTagReducer = createReducer<GroupingTagMainSliceState>(
	new GroupingTagMainSliceState(),
	on(getGroupingTagsPageSuccess, (state, action) =>
		state.setSubscriptions(action.groupingTags).setTotalItems(action.total)
	),
	on(fetchProjectCountByGroupingTagSuccess, (state, action) => {
		const updated = action.targets.reduce((groupingTags, curr) => {
			const prev = groupingTags.get(`${curr.id}`) as GroupingTagItemEntity;
			return groupingTags.set(
				`${curr.id}`,
				prev.setReferencedByCount(curr.count)
			);
		}, state.groupingTags);
		return state.setSubscriptions(updated);
	}),
	on(fetchReferencedProjectsByGroupingTagIdSuccess, (state, action) => {
		const updated = action.projects.reduce((groupingTags) => {
			const prev = groupingTags.get(`${action.id}`) as GroupingTagItemEntity;
			return groupingTags.set(
				`${action.id}`,
				prev.setProjects(action.projects)
			);
		}, state.groupingTags);
		return state.setSubscriptions(updated);
	})
);
